import SectionPanel from "pages/analytics/components/SectionPanel";
import { TableSkeleton, EmptyMessage } from "pages/analytics/components/AnalyticsStates";
import { formatPercent } from "pages/analytics/components/analyticsFormatters";

const RATE_ROWS = [
  { key: "optInToCallBookedPercent", label: "Opt-in → Call Booked" },
  { key: "bookedToShowedPercent", label: "Booked → Showed" },
  { key: "showedToClosedPercent", label: "Showed → Closed Won" },
  { key: "leadToClosePercent", label: "Lead-to-Close Rate" },
  { key: "overallConversionPercent", label: "Overall Conversion" },
];

export default function GhlConversionRates({ data, isLoading }) {
  const rates = data?.conversionRates ?? {};

  return (
    <SectionPanel title="Conversion Rates">
      {isLoading ? (
        <TableSkeleton rows={4} cols={2} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {RATE_ROWS.map((row) => (
            <div
              key={row.key}
              className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3"
            >
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                {row.label}
              </p>
              <p className="mt-1 text-2xl font-semibold text-gray-900">
                {formatPercent(rates[row.key])}
              </p>
            </div>
          ))}
        </div>
      )}

      {!isLoading && !rates.optInToCallBookedPercent && !rates.overallConversionPercent && (
        <div className="mt-4">
          <EmptyMessage message="Conversion rates populate after historical sync with stage events." />
        </div>
      )}
    </SectionPanel>
  );
}
